import { AbstractCollection } from '../../abstract/Collection';
import { AbstractDocument, Identifiable, Timestampable, Untrackable } from '../../abstract/Document';
import { type Place } from '../Places';
import { IFaq } from './Faqs.types';

@Identifiable
@Timestampable
@Untrackable
export class Facet extends AbstractDocument<IFaq> {
  readonly collections = {};
}

export class Faqs extends AbstractCollection<Facet, IFaq> {
  static path = 'faqs';

  constructor(document: Place) {
    super(document.collection(Faqs.path), Facet);
  }
}
